







































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import NavbarDark from '@/components/NavbarDark.vue';
import Footer from '@/components/Footer.vue';
import * as M from 'materialize-css';

@Component({
  components: {
    NavbarDark,
    Footer,
  },
})

export default class Faqs extends Vue {
  public mounted() {
    M.AutoInit();
  }
}
